export interface ZoomConfig {
  OAuthUri: string
  ClientId: string
  RedirectUri: string
}
export type LearningConfig = {
  microsoftTeam: Record<string, any>
  zoomConfig: ZoomConfig
}

// Biến môi trường lưu dưới client
export interface ENV {
  partnerPhoneNumbers: string[]
  partnerEmails: string[]
  organizationExamShows: string[],
  // eslint-disable-next-line camelcase
  base_router: string
  publicPath: string // Địa chỉ chứa cdn
  api: Record<string, any>
  app: Record<string, any>
  online: Boolean
  idbCacheTime: number // phút
  screentime: Record<string, any>
  socketIOPath: string
  misaIDWebUrl: string
  learningConfig: LearningConfig
  linkPageMaintain: string
  maxNumFile: number
}

declare global {
  interface Window {
    __env: ENV
    screentime: any
    io: any
  }
}

/**
 * Lấy config theo môi trường
 * @param key
 * @returns
 */
export function getEnvConfig <T extends keyof ENV> (key: T) {
  return window.__env[key]
}
